import ApiService from '@/services/api.service'

const CensusService = {

    getAllPatientCensus(parameter) {
      const params= {
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,
          PageNumber: parameter.PageNumber,
          DateFrom: parameter.DateFrom,
          DateTo: parameter.DateTo,
          Status: parameter.Status,
          PatientList: parameter.PatientList,
          InsuranceList: parameter.InsuranceList,
          ProgramList: parameter.ProgramList,
          DoctorList: parameter.DoctorList,
          Gender: parameter.Gender,
          Category: parameter.Category,
          doNotShowAnticipatedDischDate: parameter.doNotShowAnticipatedDischDate,
        }
        return ApiService.getWithArray('/PatientCensus',params);
    },
}

export default CensusService;
